import { SVGProps, Ref, forwardRef } from 'react';

export const ItAccreditationFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m8.464-1.435v-1.9h1.4v1.9h.966v1.4h-.966v3.7h-1.4v-3.7h-.966v-1.4zm-3.332 1.4v3.7h1.4v-5.1H4.665v1.4zm1.733-3.133a1.033 1.033 0 1 1-2.067 0 1.033 1.033 0 0 1 2.067 0"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ItAccreditationFilledSize16Glyph.displayName = 'ItAccreditationFilledSize16Glyph';
